import styled from 'styled-components'
import theme from '../../../styles/theme'
import ButtonBase from '../../../master/components/styled/ButtonBase'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const Box = styled.div`
  line-height: 2.95rem;
  margin: 0;
  border-top: ${theme.borderDefault};
  border-left: ${theme.borderDefault};
  border-right: ${theme.borderDefault};
`

export const Title = styled.h4`
  margin: 0px;
  padding: 0 1.2rem;
  font-size: ${theme.headingCheckout};
  font-family: ${theme.brandFontFamily};
  font-weight: 400;
  text-align: center;
`

export const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  border-bottom: ${theme.borderDefault};
`

export const Button = styled(ButtonBase)`
  border-top: 0;
`
